"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageViewEvent = exports.trackPageViewLocation = exports.trackPageView = exports.getPageLoadEvent = exports.getPageViewEvent = void 0;
const config_1 = __importDefault(require("next/config"));
const router_1 = require("next/router");
const react_1 = require("react");
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const { publicRuntimeConfig = {} } = (0, config_1.default)();
const { brand = 'HP' } = publicRuntimeConfig;
function getPageViewEvent({ language, deviceType, type, title, path, query, partner, notifications = [], user, }) {
    if (!language) {
        console.warn('Page view data `language` is not provided');
    }
    return {
        page: {
            brand,
            language: language === null || language === void 0 ? void 0 : language.toLowerCase(),
            view: deviceType,
            type,
            title,
            path,
            query,
            partner,
            shownNotifications: notifications,
        },
        user,
        event: '🚀 pageview',
    };
}
exports.getPageViewEvent = getPageViewEvent;
function getPageLoadEvent(props) {
    return Object.assign(Object.assign({}, getPageViewEvent(props)), { event: 'pageload' });
}
exports.getPageLoadEvent = getPageLoadEvent;
const trackPageView = (event) => {
    (0, libs_tracking_events_1.track)(getPageViewEvent(event));
};
exports.trackPageView = trackPageView;
const trackPageViewLocation = (path, query, language, type, view) => (0, libs_tracking_events_1.track)({
    event: '🚀 pageview',
    page: {
        brand,
        path,
        query,
        language: language === null || language === void 0 ? void 0 : language.toLowerCase(),
        type,
        view,
    },
}, { pausable: false });
exports.trackPageViewLocation = trackPageViewLocation;
function usePageViewEvent(params) {
    const pageViewLocation = (0, react_1.useRef)(null);
    const { events } = (0, router_1.useRouter)();
    (0, react_1.useEffect)(() => {
        function onUpdateComplete(url) {
            const [path, queryString] = url.split('?');
            const query = queryString ? `?${queryString}` : '';
            const { language, type, view } = params;
            const { path: prevPath, query: prevQuery } = pageViewLocation.current || {};
            if (path !== prevPath || query !== prevQuery) {
                (0, exports.trackPageViewLocation)(path, query, language, type, view);
            }
            (0, libs_tracking_events_1.unpause)();
        }
        events.on('routeChangeStart', libs_tracking_events_1.pause);
        events.on('routeChangeComplete', onUpdateComplete);
        events.on('routeChangeError', libs_tracking_events_1.unpause);
        return () => {
            events.off('routeChangeStart', libs_tracking_events_1.pause);
            events.off('routeChangeComplete', onUpdateComplete);
            events.off('routeChangeError', libs_tracking_events_1.unpause);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
exports.usePageViewEvent = usePageViewEvent;
//# sourceMappingURL=trackPageView.js.map